import React from 'react';
import { ClockCircleOutlined, FontSizeOutlined, WechatOutlined } from '@ant-design/icons';
import { Form, Flex, InputNumber, Modal, Steps, Input, message, Alert } from 'antd';
import {LoadingIcon} from '../../components/loadingIcon';
import paymentModal from '../../components/paymentModal';
import { getCurrentShopId } from '../shop/get-current-shop';


const getMiniOrderUrl = async (orderNo, shopId, accId) => {
    const response = await fetch(`/api/wxopen/wx-mini-page-short-url`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            accId,
            params: {
                page_url:`pages/order-share/index?orderNo=${orderNo}&shopId=${shopId}`,
                page_title: '订单支付'
            }
        })
    });
    const result = await response.json();

    if(result?.success) {
        console.log('orderUrl', result.data.link);
        return result.data.link;
    }else {
        // message.error('获取小程序链接失败！');
        return null;
    }
}


const itemStyle = {
    width: 'auto',
    marginBottom: 6,
}
// 上门服务订单流程
const TwoStepFlow = (props) => {
    const { order, onFlowChange, times=2, disableEvent = false, ...stepsProps } = props;
    const { orderStatus, goodsTitle, payStatus, from, unit, orderId, meta } = order;
    const [form] = Form.useForm();
    
    let defaultFlow = [
        {
            title: '到家',
            code: 4,
            status: 'process',
            icon: <LoadingIcon />,
            onClick: () => onItemClick(0),
        },
        {
            title: '商家',
            code: 6,
            status: 'wait',
            onClick: () => onItemClick(1),
        },
        {
            title: '到家',
            code: 8,
            status: 'wait',
            onClick: () => onItemClick(2),
        },
        {
            title: '完成',
            code: 12,
            status: 'wait',
            // onClick: () => onItemClick(3),
        }
    ];

    if(times === 1) {
        defaultFlow = defaultFlow.filter(item => [4, 12].includes(item.code))
    }

    // let newFlow = updateFlowItem(orderStatus, defaultFlow);
    const [flow, setFlow] = React.useState(defaultFlow);
    // const [unit, setUnit] = React.useState('');
    const flowRef = React.useRef();

    const firstForm = <Form form={form} layout={'vertical'}>
        <Form.Item
            layout="vertical"
            style={itemStyle}
            label="总金额"
            required
            name="amount"
            rules={[{ required: true, message: '请输入金额！' }]}
        >
            <InputNumber
                addonAfter="元"
                placeholder="请输入金额！"
                id='amount'
            />
        </Form.Item>
        <Flex gap={10}>
            <Form.Item
                layout="vertical"
                style={itemStyle}
                label="数量"
                required
                name="quantity"
                rules={[{ required: true, message: '请输入数量！' }]}
            >
                <InputNumber
                    style={{width: '150px'}}
                    placeholder="请输入数量！"
                    id='quantity'
                />
            </Form.Item>
            <Form.Item
                layout="vertical"
                style={itemStyle}
                label="单位"
                required
                name="unit"
                rules={[{ required: true, message: '请输入单位！' }]}
            >
                <Input id='unit' value={unit} />
            </Form.Item>
        </Flex>
    </Form>;

    const onItemClick = async (index) => {
        if(disableEvent) return false;

        let currentItem = flowRef.flow[index];
        // console.log('onItemClick', currentItem.code);
        if(currentItem.status !== 'process') return false;

        let content = null;
        if(currentItem.code === 4) {
            content = firstForm;
        }

        Modal.confirm({
            title: '请确认是否已经【' + currentItem.title + '】了？',
            // width: '98%',
            content,
            icon: null,
            okText: '确认',
            cancelText: '取消',
            onOk: async () => {
                if(currentItem.code === 4){
                    const fields = await form.validateFields();
                    let amount = fields.amount * 100;
                    let quantity = fields.quantity;
                    let unit = fields.unit;
                    // console.log('amount', amount, quantity, unit);

                    // if (!shopId) {
                    //     message.error('未能获取店铺ID，请稍后重试');
                    //     return;
                    // }
                    const orderData = {
                        orderStatus: currentItem.code,
                        quantity: +quantity,
                        unit,
                    }

                    if(meta?.skuId && meta?.skuList) {
                        const sku = meta.skuList.find(i => i.skuId === meta.skuId);

                        if(sku) {
                            orderData.amount = sku.price * quantity;
                        }
                    }else if(meta?.goodsInfo?.price){
                        orderData.amount = meta.goodsInfo.price * quantity;
                    }

                    if(payStatus === 0) {
                        orderData.shouldAmount = +amount;
                        orderData.realAmount = +amount;
                    } else if(payStatus === 1) {
                        orderData.realAmount = +amount;
                    }

                    let result = await updateOrderStatus(orderData);
        
                    if(result.success) {
                        onFlowChange?.();
                    }
                }else if(![10, 12].includes(currentItem.code)){
                    // if (!shopId) {
                    //     message.error('未能获取店铺ID，请稍后重试');
                    //     return;
                    // }
                    let result = await updateOrderStatus({
                        orderStatus: currentItem.code
                    });
        
                    if(result.success) {
                        onFlowChange?.();
                    }
        
                }else{
                    message.error({ content: '此流程不能手动操作！' });
                }
            },
        });
    }

    React.useEffect(() => {
        let newFlow = updateFlowItem(orderStatus, flow);
        flowRef.flow = newFlow;
        setFlow(newFlow);
    }, [orderStatus]);

    React.useEffect(() => {
        form.setFieldsValue({
            amount: order.shouldAmount/100,
            quantity: order.quantity,
            unit: order.unit,
        });
    }, [order]);

    const updateOrderStatus = async (data) => {
        const shopId = await getCurrentShopId();
        if (!shopId) {
            message.error('无法提交：未获取到店铺信息');
            return { success: false, data: 'Missing shopId' };
        }

        try {
            const response = await fetch(`/api/order/update?shopId=${shopId}&orderId=${orderId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });

            const result = await response.json();

            if (result.success) {
                message.success('操作成功！');
            } else {
                message.error(result.data || '操作失败');
            }

            return result;
        } catch (error) {
            message.error('网络请求出错，请检查连接');
            return { success: false, data: error.message };
        }
    };

    return (
        <Steps
            size="small"
            direction="horizontal"
            responsive={false}
            {...stepsProps}
            items={flow}
        />
    )
}

// 支付流程组件
const PayFlow = (props) => {
    const { order, disableEvent, onFlowChange = () => {}, style={} } = props;
    const { payStatus, orderStatus, from } = order;

    const onItemClick = async (index) => {
        if(disableEvent) return false;
        console.log('order', order);
        const info = order?.appointment;
        console.log('info', info);

        const alertInfo = <div>
            客户资料:
            <Alert description={
                <div>
                    <li>姓名：{info?.customerName}</li>
                    <li>手机：{info?.phoneNo}</li>
                    <li>地址：{info?.county + info?.address}</li>
                </div>
            } type="warning" />
        </div>

        const orderUrl = await getMiniOrderUrl(order.orderNo, order.shopId, order.accId);
        
        paymentModal({orderNo: order.orderNo, orderUrl, shopId: order.shopId, accId:order.accId, amount: order.shouldAmount/100, onFlowChange, ...order}, alertInfo);
    }

    return (
        // <Flex gap={10} justify='start-end' style={style}>
        //     {/* <Steps
        //         size="small"
        //         direction="horizontal"
        //         responsive={false}
        //         {...props}
        //         items={flow}
        //     /> */}
        //     <Button onClick={() => onItemClick(0)} type='primary'>收款</Button>
        //     {/* <div>
        //         <LoadingIcon style={{fontSize: '20px'}} /> 已支付
        //     </div> */}
        // </Flex>
        <span onClick={() => onItemClick(0)} type='primary'>收款</span>
    )
}

// 快递/物流发货流程
const DeliveryFlow = (props) => { 
    const { order, onFlowChange, disableEvent = false, ...stepsProps } = props;
    const { orderStatus, goodsTitle, payStatus, from, unit, orderId, meta } = order;
    const [form] = Form.useForm();
    
    let defaultFlow = [
        {
            title: '发货',
            code: 8,
            status: 'wait',
            icon: <LoadingIcon />,
        },
        {
            title: '确认收货',
            code: 10,
            status: 'wait',
        },
        {
            title: '完成',
            code: 12,
            status: 'wait',
            // onClick: () => onItemClick(3),
        }
    ];

    const [flow, setFlow] = React.useState(defaultFlow);
    const flowRef = React.useRef();


    React.useEffect(() => {
        let newFlow = updateFlowItem(orderStatus, flow);
        flowRef.flow = newFlow;
        setFlow(newFlow);
    }, [orderStatus]);

    // React.useEffect(() => {
    //     form.setFieldsValue({
    //         amount: order.shouldAmount/100,
    //         quantity: order.quantity,
    //         unit: order.unit,
    //     });
    // }, [order]);

    return (
        <Steps
            size="small"
            direction="horizontal"
            responsive={false}
            {...stepsProps}
            items={flow}
        />
    )
}

// 根据订单状态返回不同的流程组件
const FlowGroup = (props) => {
    const { order, onFlowChange, ...others } = props;
    const { from } = order;
    // console.log('orderStatus', orderStatus);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    // const {message} = App.useApp();
    const handleOk = async () => {
        setIsModalOpen(false);
        
        // const result = await fulfill({
        //     orderNo,
        //     isSplitPackage: true,
        //     fulfillMethod: 2,
        //     fulfillItems: [{orderItemId: itemId, skuNum }],
        // });

        if(typeof onFlowChange === 'function') {
            onFlowChange();
        }

        // if(result.data?.code?.errcode === '0') {
        //     message.success('发货成功');
        // } else {
        //     message.error(result.data?.code?.errmsg);
        // }
    }

    const handleCancel = () => {
        setIsModalOpen(false);
    }

    return (
        <>
            <PayFlow {...props} />
            <TwoStepFlow style={{margin: '8px 0 0 0'}} {...props} />
        </>
    )
}

const updateFlowItem = (newOrderStatus, lastFlow = []) => {
    // console.log('updateFlowItem', newOrderStatus);
    let cur = -1;
    let newFlow = lastFlow.map((item, index) => {

        // item.onClick = () => onItemClick(index);

        if(newOrderStatus > item.code) {
            return { ...item, status: 'finish', icon: null }
        }else if(newOrderStatus === item.code) {
            return { ...item, status: 'finish', icon: null }
        } else {
            if(cur === -1 && newOrderStatus < item.code) {
                cur = index;
                return { ...item, status: 'process', icon: <LoadingIcon /> }
            }

            return { ...item, status: 'wait', icon: null }
        }
    });

    return newFlow;
}


export { FlowGroup, PayFlow, TwoStepFlow, DeliveryFlow };